import React from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import { config } from "../../../../../../_config";

const { email } = config;
const StyledTermsSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;

  .privacy-body {
    width: 980px;

    padding-top: 1rem;
    padding-bottom: 1rem;

    p {
      margin-bottom: 20px;
      font-family: "MerriweatherLight";
      font-size: 13px;
      line-height: calc(1.42857rem * (13 / 16));
      text-align: left;
      color: #424242;
    }

    ul {
      margin-bottom: 0;
      padding-left: 28px;

      li {
        font-family: "MerriweatherLight";
        font-size: 13px;
        line-height: 24px;
        text-align: left;
        color: #424242;
      }

      &.secondary-list {
        list-style-type: none;
        padding-left: 0;

        li {
          cursor: pointer;

          &:hover {
            color: #244f74;
          }
        }
      }
    }

    .primary-title,
    .secondary-title {
      font-family: "MerriweatherBold";
      color: #244f74;
    }

    .primary-title {
      text-transform: uppercase;
    }

    .main-content {
      padding: 15px;
    }
  }

  @media ${({ theme }) => theme.devices.laptopS} {
    .privacy-body {
      width: 720px;
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    .privacy-body {
      width: 100%;

      padding-top: 28px;
      padding-bottom: 8px;
      padding-left: 9px;
      padding-right: 9px;

      .main-content {
        padding-top: 0;
        padding-left: 6px;
        padding-right: 6px;
      }
    }
  }
`;

function TermsSection() {
  const handleScroll = (e) => {
    const { id } = e.target;
    const anchor = document.getElementById(`terms-content-title-${id.replace("terms-content-trigger-", "")}`);
    anchor?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <StyledTermsSection>
      <div className="privacy-body">
        <div className="main-content">
          <p className="primary-title">TABLE OF CONTENTS</p>
          <p>
            <Row>
              <Col xs={12} md={6}>
                <ul className="secondary-list" onClick={handleScroll}>
                  <li id="terms-content-trigger-1">Limited License for use of Website</li>
                  <li id="terms-content-trigger-2">Limitations on Use</li>
                  <li id="terms-content-trigger-3">Not Legal Advice</li>
                  <li id="terms-content-trigger-4">Intellectual Property Rights</li>
                  <li id="terms-content-trigger-5">
                    Digital Millennium Copyright Act - Notification of Alleged Copyright Infringement
                  </li>
                  <li id="terms-content-trigger-6">No Solicitation</li>
                  <li id="terms-content-trigger-7">Advertisers</li>
                  <li id="terms-content-trigger-8">Cancellation</li>
                  <li id="terms-content-trigger-9">Refunds</li>
                  <li id="terms-content-trigger-10">Service Charges</li>
                  <li id="terms-content-trigger-11">Errors and Corrections</li>
                  <li id="terms-content-trigger-12">Third Party Content</li>
                </ul>
              </Col>
              <Col xs={12} md={6}>
                <ul className="secondary-list" onClick={handleScroll}>
                  <li id="terms-content-trigger-13">Disclaimer</li>
                  <li id="terms-content-trigger-14">Limitation of Liability</li>
                  <li id="terms-content-trigger-15">Force Majeure</li>
                  <li id="terms-content-trigger-16">Indemnification</li>
                  <li id="terms-content-trigger-17">Third Party Rights</li>
                  <li id="terms-content-trigger-18">Unlawful Activity & Termination of Access</li>
                  <li id="terms-content-trigger-19">Information Provided</li>
                  <li id="terms-content-trigger-20">Remedies for Violations</li>
                  <li id="terms-content-trigger-21">Governing Law and Jurisdiction</li>
                  <li id="terms-content-trigger-22">Privacy</li>
                  <li id="terms-content-trigger-23">Severability of Provisions</li>
                  <li id="terms-content-trigger-24">Modifications to Terms of Use</li>
                </ul>
              </Col>
            </Row>
          </p>
          <p id="terms-content-title-1" className="secondary-title">
            Limited License for use of Website
          </p>
          <p>
            As a user of this Website you are granted a revocable, nontransferable, nonexclusive, limited license to use
            and access this Website and Content in conformity with these Terms of Use. The license may be terminated by
            the Provider at any time for any reason without notice.
          </p>
          <p id="terms-content-title-2" className="secondary-title">
            Limitations on Use
          </p>
          <p>
            The Content on this Website is only for your personal use and not for commercial usage. Furthermore, you may
            not disassemble, reverse engineer, decompile, lease, rent, sublicense, loan, sell, or create derivative
            works from this Website or the Content. You may not use any network monitoring or discovery software to
            determine the site architecture, or extract information about usage, individual identities or users. You may
            not use any robot, spider, other automatic software or device, or manual process to monitor or copy this
            Website or the Content without Provider&apos;s prior written permission. You may not use this Website to
            transmit any false, misleading, fraudulent or illegal communications. You may not copy, modify, reproduce,
            republish, distribute, display, or transmit for commercial, non-profit or public purposes all or any portion
            of this Website. You may not use or otherwise export or re-export this Website or any portion thereof, or
            the Content in violation of the export control laws and regulations of the United States of America. Any
            unauthorized use of this Website or its Content is prohibited.
          </p>
          <p id="terms-content-title-3" className="secondary-title">
            Not Legal Advice
          </p>
          <p>
            Content is not intended to and does not constitute legal advice and no attorney-client relationship is
            formed, nor is anything submitted to this Website treated as confidential. The accuracy, completeness,
            adequacy or currency of the Content is not warranted or guaranteed. Your use of the Content on this Website
            or materials linked from this Website is at your own risk.
          </p>
          <p id="terms-content-title-4" className="secondary-title">
            Intellectual Property Rights
          </p>
          <p>
            All materials on this Website, including without limitation to all informational text, photographs,
            graphics, audio, videos, messages, files, documents, images or other materials, whether publicly posted or
            privately transmitted, as well as all derivative works, are owned by Provider or other parties that have
            licensed their material to Provider and are protected by copyright, trademark and/or other intellectual
            property laws. Provider disclaims any proprietary interest in trademarks, service marks, logos, slogans,
            domain names and trade names other than its own. Trademarks, logos, images and service marks displayed on
            the Website are the property of either Provider or other third parties. You agree not to copy, reproduce,
            republish, upload, modify, post, transmit, distribute, display or use such marks without written permission
            from Provider or the appropriate party.
          </p>
          <p>
            If you have completed a survey given to you by Provider, you agree that the information obtained can be used
            by Provider. Furthermore, you grant Provider an irrevocable, non-exclusive, royalty-free, perpetual,
            worldwide license to use, authorize use of and have used on its behalf any ideas, expression of ideas, text,
            graphics, messages, blogs, links, data, information and other materials you submit to this Website. Said
            license is without restrictions of any kind and without any payment due from Provider to you or permission
            or notification, to you or any third party. The license includes, the right to make, use, sell, reproduce,
            publish, modify, adapt, prepare derivative works from, combine with other works, translate, distribute,
            display, perform and sublicense the information from the survey, in any form, medium, or technology now
            known or hereafter developed.
          </p>
          <p id="terms-content-title-5" className="secondary-title">
            Digital Millennium Copyright Act - Notification of Alleged Copyright Infringement
          </p>
          <p>
            Provider avails itself of the protections under the terms of the Digital Millennium Copyright Act. Also,
            Provider reserves the right to remove any content that allegedly infringes upon another person&apos;s
            copyright. Notices to Provider regarding any alleged copyright infringement should be directed to Provider
            via the contact form.
          </p>
          <p id="terms-content-title-6" className="secondary-title">
            No Solicitation
          </p>
          <p>
            You may not distribute on or through this Website any postings containing any advertising, promotion,
            solicitation for goods, services or funds or solicitation for others to become members of any enterprise or
            organization without the express written permission of Provider. Notwithstanding the foregoing, in any
            interactive areas of this Website, where appropriate you a) may list along with your name, address and email
            address, your own web site&apos;s URL and b) may recommend third party web sites, goods or services so long
            as you have no financial interest in and receive no direct or indirect benefit from such recommended web
            site, product or service or its recommendation. In no event may any person or entity solicit anyone with
            data retrieved from this Website.
          </p>
          <p id="terms-content-title-7" className="secondary-title">
            Advertisers
          </p>
          <p>
            This Website may contain advertising and sponsorship. Advertisers and sponsors are responsible for ensuring
            that material submitted for inclusion on this Website is accurate and complies with applicable laws.
            Provider will not be responsible for the illegality of or any error or inaccuracy in advertisers&apos; or
            sponsors&apos; materials or for the acts or omissions of advertisers and sponsors.
          </p>
          <p id="terms-content-title-8" className="secondary-title">
            Cancellation
          </p>
          <p>
            When you place an order through the Services, your order begins processing immediately. Due to the varying
            nature of processing times, you may request cancellation after your order has been placed but we cannot
            guarantee that your order will be canceled. You may be able to cancel your order for the Services if your
            order has not begun processing and you contact us within one (1) hour of placing your order via email at{" "}
            <a href={`mailto:${email}?subject=Mail from Contact Us USA Taxid Site`}>{email}</a>&nbsp; or by calling{" "}
            <a href="tel:1-800-317-5781"> 1-800-317-5781</a>. Upon successful cancellation we will refund your order in
            full to the original form of payment.
          </p>
          <p id="terms-content-title-9" className="secondary-title">
            Refunds
          </p>
          <p>
            When you place an order, your order begins processing immediately. Due to the varying nature of processing
            times, you may request cancellation after your order has been placed, but we cannot guarantee that your
            order will be canceled. You may be able to cancel your order by contacting customer service.
          </p>
          <p>Your order is no longer refundable once we have submitted to the State/IRS.</p>
          <p>
            Any approved refunds must be requested within six (6) months of the original purchase date. Refund requests
            submitted more than six (6) months after the order purchase date will not be eligible for a refund.
          </p>
          <p id="terms-content-title-10" className="secondary-title">
            Service Charges
          </p>
          <p>
            Service charges and delivery times are explained at or before the point of checkout and are subject to
            change.
          </p>
          <p>
            The related service charges are for the use of Provider&apos;s simplified application generation services.
            No fees are related to submitting the SS-4 application. Provider offers the services of reviewing your
            answers for completeness, spelling and grammar only. Provider does not charge for the SS-4 application. A
            blank copy can be provided for free on the IRS website.
          </p>
          <p id="terms-content-title-11" className="secondary-title">
            Errors and Corrections
          </p>
          <p>
            Provider does not represent or warrant that this Website or the Content will be error-free, free of viruses
            or other harmful components, or that defects will be corrected or that it will always be accessible.
            Provider does not warrant or represent that the Content available on or through this Website will be
            correct, accurate, timely, or otherwise reliable. Provider may make improvements and/or changes to its
            features, functionality or Content at any time.
          </p>
          <p id="terms-content-title-12" className="secondary-title">
            Third Party Content
          </p>
          <p>
            Third party content may appear on this Website or may be accessible via links from this Website. Provider
            shall not be responsible for and assumes no liability for any infringement, mistakes, misstatements of law,
            defamation, slander, libel, omissions, falsehood, obscenity, pornography or profanity in the statements,
            opinions, representations or any other form of content contained in any third party content appearing on
            this Website. You understand that the information and opinions in the third party content is neither
            endorsed by nor does it reflect the belief or opinion of Provider.
          </p>
          <p id="terms-content-title-13" className="secondary-title">
            DISCLAIMER
          </p>
          <p>
            THIS WEBSITE, THE CONTENT AND THE SERVICES RENDERED ARE PROVIDED ON AN &quot;AS IS&quot; BASIS. PROVIDER
            EXPRESSLY DISCLAIMS ALL WARRANTIES, INCLUDING THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NON-INFRINGEMENT. PROVIDER DISCLAIMS ALL RESPONSIBILITY FOR ANY LOSS, INJURY, CLAIM, LIABILITY,
            OR DAMAGE OF ANY KIND RESULTING FROM, ARISING OUT OF OR ANY WAY RELATED TO (A) ANY ERRORS IN OR OMISSIONS
            FROM THIS WEBSITE, THE CONTENT AND SERVICES RENDERED, INCLUDING, BUT NOT LIMITED TO, TECHNICAL INACCURACIES
            AND TYPOGRAPHICAL ERRORS, (B) THIRD PARTY COMMUNICATIONS OR THIRD PARTY SERVICES, (C) ANY THIRD PARTY WEB
            SITES OR CONTENT THEREIN DIRECTLY OR INDIRECTLY ACCESSED THROUGH LINKS IN THIS WEB SITE, INCLUDING BUT NOT
            LIMITED TO ANY ERRORS IN OR OMISSIONS THEREFROM, (D) THE UNAVAILABILITY OF THIS WEBSITE, THE CONTENT,
            SERVICES OR ANY PORTION THEREOF, (E) YOUR USE OF THIS WEBSITE, THE CONTENT, OR SERVICES RENDERED (F) YOUR
            USE OF ANY EQUIPMENT OR SOFTWARE IN CONNECTION WITH THIS WEBSITE, THE CONTENT, AND SERVICES RENDERED.
          </p>
          <p>
            PROVIDER IS NOT AFFILIATED WITH ANY GOVERNMENT AGENCY. THE FEES ARE COLLECTED TO COVER ANY RELATED
            ASSISTANCE YOU MAY NEED WHEN COMPLETING THE APPLICATIONS, WHICH INCLUDES BUT NOT LIMITED TO, CUSTOMER
            SERVICE ASSISTANCE, VIA PHONE OR EMAIL. PROVIDER DOES NOT CHARGE ANY FEES FOR THE ACTUAL APPLICATIONS OR
            FORMS. BLANK FORMS CAN BE OBTAINED FOR FREE ON THE RESPECTIVE GOVERNMENT WEBSITES.
          </p>
          <p id="terms-content-title-14" className="secondary-title">
            LIMITATION OF LIABILITY
          </p>
          <p>
            PROVIDER SHALL NOT BE LIABLE FOR ANY LOSS, INJURY, CLAIM, LIABILITY, OR DAMAGE OF ANY KIND RESULTING FROM
            YOUR USE OF THIS WEBSITE, THE CONTENT, OR SERVICES RENDERED, PROVIDER SHALL NOT BE LIABLE FOR ANY SPECIAL,
            DIRECT, INDIRECT, INCIDENTAL, PUNITIVE OR CONSEQUENTIAL DAMAGES OF ANY KIND WHATSOEVER (INCLUDING, WITHOUT
            LIMITATION, ATTORNEYS&apos; FEES) IN ANY WAY DUE TO, RESULTING FROM, OR ARISING IN CONNECTION WITH THE USE
            OF OR INABILITY TO USE THIS WEBSITE, THE CONTENT, OR SERVICES.
          </p>
          <p id="terms-content-title-15" className="secondary-title">
            Force Majeure
          </p>
          <p>
            Provider will not be considered in breach of or default under these Terms of Use or any contract with you,
            and will not be liable to you for any cessation, interruption, or delay in the performance of its
            obligations herein by reason of earthquake, flood, fire, storm, lightning, drought, landslide, hurricane,
            cyclone, typhoon, tornado, natural disaster, act of God or the public enemy, epidemic, famine or plague,
            action of a court or public authority, change in law, explosion, war, terrorism, armed conflict, labor
            strike, lockout, government shutdown, boycott or similar event beyond our reasonable control, whether
            foreseen or unforeseen event. If any of these events continues for more than 60 days in the aggregate,
            Provider may immediately terminate these Terms of Use and shall have no liability to you for or as a result
            of any such termination.
          </p>
          <p id="terms-content-title-16" className="secondary-title">
            Indemnification
          </p>
          <p>
            You agree to indemnify, defend and hold Provider, its officers, directors, employees, and agents harmless
            against any and all claims, losses, expenses, damages and costs, including reasonable attorneys&apos; fees,
            resulting from any violation of these Terms of Use by you.
          </p>
          <p id="terms-content-title-17" className="secondary-title">
            Third Party Rights
          </p>
          <p>
            The provisions of paragraphs 13 (Disclaimer), 14 (Limitation of Liability), and 16 (Indemnification) are for
            the benefit of Provider and its officers, directors, employees, and agents. Each of these individuals or
            entities shall have the right to assert and enforce those provisions directly against you on its own behalf.
          </p>
          <p id="terms-content-title-18" className="secondary-title">
            Unlawful Activity & Termination of Access
          </p>
          <p>
            Provider reserves the right to investigate complaints or reported violations of our Terms of Use and to take
            any action we deem appropriate including but not limited to reporting any suspected unlawful activity to law
            enforcement officials, regulators, or other third parties and disclosing any information necessary or
            appropriate to such persons or entities relating to user profiles, e-mail addresses, usage history, posted
            materials, IP addresses and traffic information. Provider may discontinue any party&apos;s participation in
            any of the interactive areas at any time for any reason or no reason.
          </p>
          <p id="terms-content-title-19" className="secondary-title">
            Information Provided
          </p>
          <p>
            You agree that by using this Website you are at least 18 years of age and the actual said person completing
            the application and not an individual acting on someone else&apos;s behalf. You agree that you are
            responsible for making sure that all documents submitted for the purpose of obtaining Provider&apos;s
            services is truthful and legally correct. You agree that any and all information provided to this Website is
            not fraudulent in any manner. Intentionally falsifying information may subject the applicant to criminal
            prosecution by the US Government. Provider will only provide personal information to third parties when
            obligated by state and federal authorities.
          </p>
          <p id="terms-content-title-20" className="secondary-title">
            Remedies for Violations
          </p>
          <p>
            Provider reserves the right to seek all remedies available at law and in equity for violations of these
            Terms of Use, including but not limited to the right to block access from a particular internet address to
            this Website and any other websites and their features belonging to the Provider.
          </p>
          <p id="terms-content-title-21" className="secondary-title">
            Governing Law and Jurisdiction
          </p>
          <p>
            The Terms of Use are governed by and construed in accordance with the laws of the State of Florida and any
            action arising out of or relating to these terms shall be filed only in state or federal courts located in
            Florida and you hereby consent and submit to the personal jurisdiction of such courts for the purpose of
            litigating any such action.
          </p>
          <p id="terms-content-title-22" className="secondary-title">
            Privacy
          </p>
          <p>Your use of this Website is subject to Provider&apos;s Privacy Policy.</p>
          <p id="terms-content-title-23" className="secondary-title">
            Severability of Provisions
          </p>
          <p>
            These Terms of Use incorporate by reference any notices contained on this Website and the Privacy Policy
            constitute the entire agreement with respect to access to and use of this Website and the Content. If any
            provision of these Terms of Use is unlawful, void or unenforceable, that provision shall be deemed severable
            from the remaining provisions and shall not affect their validity and enforceability.
          </p>
          <p id="terms-content-title-24" className="secondary-title">
            Modifications to Terms of Use
          </p>
          <p>
            Provider reserves the right to change these Terms of Use at any time. Updated versions of the Terms of Use
            will appear on this Website and are effective immediately. You are responsible for regularly reviewing the
            Terms of Use. Continued use of this Website after any such changes constitutes your consent to such changes.
          </p>
        </div>
      </div>
    </StyledTermsSection>
  );
}

export default TermsSection;
